/** The support chat's `entry_point` when a plan change has to be done by support. */
export const PLAN_CHANGE_SUPPORT_ENTRY = 'cambio_de_plan';
